import { v4 as uuidv4 } from 'uuid';
import { size } from 'lodash';

import { dateUtil } from '@xtnd/web/shared/utils';

import type { AttorneyResponsePayload, MatterInvoiceSummaryFile } from '../types';

export const ANIMATION_DELAY_200MS_STYLE = { animationDelay: '0.2s' } as const;

export interface LineItem {
  id: string;
  lineNumber: string;
  comment: string;
}

export interface LineItemErrors {
  lineNumber?: string;
  comment?: string;
}

export const DEFAULT_LINE_ITEM: LineItem = {
  id: uuidv4(),
  lineNumber: '',
  comment: '',
};

export function isUnauthorizedErrorMessage(error: unknown): boolean {
  if (!error) return false;
  const errorMessage = error instanceof Error ? error.message : String(error);
  return (
    errorMessage.toLowerCase().includes('not authorized') ||
    errorMessage.toLowerCase().includes('unauthorized')
  );
}

export function formatResponseTimestamp(value?: string): string {
  return dateUtil.formatDate(
    new Date(value || new Date().toISOString()),
    dateUtil.DateFormat.US_WITH_TIME
  );
}

export function buildAttorneyResponsePayload(
  selectedOption: 'appeal' | 'no-appeal',
  lineItems: LineItem[],
  attachmentsPayload: MatterInvoiceSummaryFile[],
): AttorneyResponsePayload {
  const payload: AttorneyResponsePayload = {
    appealAction: selectedOption === 'appeal' ? 'APPEAL' : 'NO_APPEAL',
    lineItems: [],
    attachments: [],
  };

  if (selectedOption === 'appeal') {
    payload.attachments = attachmentsPayload;

    if (size(lineItems) > 0) {
      for (const item of lineItems) {
        const lineItemId = uuidv4();
        payload.lineItems.push({
          lineItemId,
          lineNumber: item.lineNumber,
          comment: item.comment,
        });
      }
    }
  }

  return payload;
}
